import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    id: 'studio.gHMvwI',
    defaultMessage: 'Resource: {resourceName}',
  },
  resources: {
    id: 'studio.c/KktL',
    defaultMessage: 'Resources',
  },
  actions: {
    id: 'studio.wL7VAE',
    defaultMessage: 'Actions',
  },
  update: {
    defaultMessage: 'Update',
    id: 'studio.BWpuKl',
  },
  cancelButton: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  createButton: {
    id: 'studio.VzzYJk',
    defaultMessage: 'Create',
  },
  deleteButton: {
    id: 'studio.K3r6DQ',
    defaultMessage: 'Delete',
  },
  delete: {
    id: 'studio.zX/a3U',
    defaultMessage: 'Delete {amount} {amount, plural, one {resource} other {resources}}',
  },
  newTitle: {
    id: 'studio.S3AgyI',
    defaultMessage: 'Creating new {resource}',
  },
  createError: {
    id: 'studio.5lOKUP',
    defaultMessage: 'Something went wrong when creating a new resource.',
  },
  uniqueConstraintViolation: {
    id: 'studio.fqFLYK',
    defaultMessage:
      'Can’t create this {resourceType} yet: another resource already has the same values for {fields}.',
  },
  importSuccess: {
    id: 'studio.RN522K',
    defaultMessage: 'Successfully imported resources {ids}',
  },
  importError: {
    id: 'studio.bK7FfL',
    defaultMessage: 'Something went wrong when creating the new resources.',
  },
  empty: {
    id: 'studio.w3ATo0',
    defaultMessage: 'Currently there are no {type} resources available.',
  },
  loading: {
    id: 'studio.QQDup8',
    defaultMessage: 'Loading {type} resources',
  },
  loadError: {
    id: 'studio.gzNgBA',
    defaultMessage: 'Something went wrong when loading this resource.',
  },
  createSuccess: {
    id: 'studio.cil1uU',
    defaultMessage: 'Successfully created resource {id}.',
  },
  export: {
    id: 'studio.GJT9SF',
    defaultMessage: 'Export as CSV',
  },
  import: {
    id: 'studio.pr6SmF',
    defaultMessage: 'Import from file',
  },
  id: {
    id: 'studio.qlcuNQ',
    defaultMessage: 'ID',
  },
  author: {
    id: 'studio.tWkQ2J',
    defaultMessage: 'Author',
  },
  editor: {
    id: 'studio.fWKwFM',
    defaultMessage: 'Editor',
  },
  hideButton: {
    id: 'studio.kiTtTY',
    defaultMessage: 'Hide columns ({count}/{total})',
  },
  advancedOptions: {
    id: 'studio.0cEOKu',
    defaultMessage: 'Advanced options',
  },
  apply: {
    id: 'studio.EWw/tK',
    defaultMessage: 'Apply',
  },
  hideProperties: {
    id: 'studio.om8L5e',
    defaultMessage: 'Hide properties',
  },
  hideExplanation: {
    id: 'studio.9hSnRE',
    defaultMessage:
      'Hide properties from the table. Hidden properties will also be hidden when exporting the properties as CSV.',
  },
  advancedOptionsExplanation: {
    id: 'studio.Xw/F4c',
    defaultMessage:
      'Apply filter options to your resources, these options will also be applied when exporting the CSV.',
  },
  created: {
    id: 'studio.ORGv1Q',
    defaultMessage: 'Created',
  },
  updated: {
    id: 'studio.xrk6zg',
    defaultMessage: 'Updated',
  },
  clonable: {
    id: 'studio.4xEqDf',
    defaultMessage: 'Clonable',
  },
  seed: {
    id: 'studio.T0E3nw',
    defaultMessage: 'Seed',
  },
  ephemeral: {
    id: 'studio.fjPJRz',
    defaultMessage: 'Ephemeral',
  },
  resourceWarningTitle: {
    id: 'studio./YHD8C',
    defaultMessage: 'Deletion warning',
  },
  resourceWarning: {
    id: 'studio.0D+2Vq',
    defaultMessage:
      'Are you sure you want to delete {amount, plural, one {this resource} other {these resources}}? Deleted resources can not be recovered.',
  },
  deleteSuccess: {
    id: 'studio.gV6QCp',
    defaultMessage: 'Successfully deleted the selected resources.',
  },
  deleteError: {
    id: 'studio.CqWqJp',
    defaultMessage: 'Something went wrong when deleting the selected resources.',
  },
  api: {
    id: 'studio.xwEc8K',
    defaultMessage: 'API',
  },
  file: {
    id: 'studio.gyrIEl',
    defaultMessage: 'File',
  },
  delimiter: {
    id: 'studio.Cj3YE3',
    defaultMessage: 'Delimiter',
  },
  chooseFile: {
    id: 'studio.86RD6b',
    defaultMessage: 'Choose file…',
  },
  noFile: {
    id: 'studio.FTFqXw',
    defaultMessage: 'No file chosen',
  },
  delimiterHelp: {
    id: 'studio.3nhRA0',
    defaultMessage:
      'A csv delimiter is a character used to separate data values in a structured text format; use <bold>\\t</bold> for tabs',
  },
});
